import { Box, ConfirmationModal, Text } from '@modusign/design-system';
import { useHistory } from 'react-router';

export type InPersonBlockFeature =
  | 'SIGN_REQUEST'
  | 'SIGN_REQUEST_WITH_APPROVAL'
  | 'SIGN_REQUEST_RETRY'
  | 'NONE';

type AlertMessage = {
  title: string;
  description: string;
};

const messages: Record<InPersonBlockFeature, AlertMessage | undefined> = {
  SIGN_REQUEST: {
    title: '서명 요청 안내',
    description: `이용 중인 요금제에 '대면서명' 기능이 없어 서명 요청을 할 수 없습니다.\n요금제를 확인해 주세요.`,
  },
  SIGN_REQUEST_WITH_APPROVAL: {
    title: '서명 요청 안내',
    description: `이용 중인 요금제에 '대면서명' 기능이 없어 결재 요청을 할 수 없습니다.\n요금제를 확인해 주세요.`,
  },
  SIGN_REQUEST_RETRY: {
    title: '서명 요청 재시도 안내',
    description: `이용 중인 요금제에 '대면서명' 기능이 없어 재시도 할 수 없습니다.\n요금제를 확인해 주세요.`,
  },
  NONE: undefined,
};

export interface InPersonPermissionAlertModalProps {
  action: InPersonBlockFeature;
  onClickClose: () => void;
}

export default function InPersonPermissionAlertModal({
  action,
  onClickClose,
}: InPersonPermissionAlertModalProps) {
  const message = messages[action];
  const history = useHistory();

  const onConfirm = () => {
    history.push('/settings/plan');
  };

  if (!message) {
    return null;
  }

  return (
    <ConfirmationModal
      closeButtonLabel="닫기"
      confirmButtonLabel="요금제 확인하기"
      isOpen
      maxWidth="sm"
      title={message.title}
      variant="warning"
      onClose={onClickClose}
      onConfirm={onConfirm}
    >
      <Box px={8}>
        <Text as="p" textAlign="center">
          {message.description}
        </Text>
      </Box>
    </ConfirmationModal>
  );
}
